module.exports = __webpack_public_path__ + "static/media/charm.c13c39c8.png";